<template>
  <div class="b-menu" :class="{'open' : isOpen}">
    <div class="b-bun b-bun--top"></div>
    <div class="b-bun b-bun--mid"></div>
    <div class="b-bun b-bun--bottom"></div>
  </div>
</template>

<script>
export default {
  name: "hamburgerMenu",
  props:["isOpen"]
}
</script>

<style scoped>

.b-menu{
  display: none;
}

@media (max-width: 767px) {
  .b-menu {
    border-radius: 50%;
    cursor: pointer;
    display: inline-block;
    height: 22px;
    transition: all 0.4s ease;
    user-select: none;
    width: 25px;
    z-index: 12;
    position: absolute;
    transform: translateY(10px) !important;
    right: 2%;
    top: 10px;
  }
  .b-bun {
    background: white;
    position: relative;
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;
    height: 2px;
    width: 25px;
  }
  .b-bun--top {
    top: 0;
  }
  .b-bun--mid {
    top: 8px;
  }
  .b-bun--bottom {
    top: 16px;
  }
  .open .b-bun--top {
    background: white;
    top: 9px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .open .b-bun--mid {
    opacity: 0;
  }
  .open .b-bun--bottom {
    background: white;
    top: 5px !important;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }










}
</style>